<template>
  <div class="BIDGraphics">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex xs12>
          <v-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-autocomplete
                    :items="questions"
                    label="Pregunta"
                    v-model="req"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>
            </v-container>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                class="text-xs-center"
                :size="progressSize"
                :width="progressWidth"
                color="info"
                indeterminate
              ></v-progress-circular>
            </v-card-text>

            <v-container v-else grid-list-md>
              <v-layout wrap>
                <v-flex xs12 md6>
                  <v-card>
                    <v-tabs
                      v-model="tabs"
                      fixed-tabs
                      color="transparent"
                      slider-color="iK"
                    >
                      <v-tab :key="bar" ripple>
                        <v-icon color="info">bar_chart</v-icon>
                      </v-tab>
                      <v-tab :key="pie" ripple>
                        <v-icon color="info">pie_chart</v-icon>
                      </v-tab>

                      <v-tab-item :key="bar">
                        <v-card-text>
                          <chart-column
                            :chartOptions="chartOptions"
                            :chartSeries="chartSeries"
                            :key="chartKey"
                          />
                        </v-card-text>
                      </v-tab-item>

                      <v-tab-item :key="pie">
                        <v-card-text>
                          <pie-chart
                            :chartOptions="pieOptions"
                            :chartSeries="pieSeries"
                            :key="pieKey"
                          />
                        </v-card-text>
                      </v-tab-item>
                    </v-tabs>
                  </v-card>
                </v-flex>

                <v-flex xs12 md6>
                  <v-card>
                    <v-card-actions>
                      <v-spacer/>
                      <v-btn color="info" :disabled="dataVals === null">
                        <download-csv
                          :data="dataVals"
                          :name="name"
                          :labels="labels"
                        >
                          <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                        </download-csv>
                      </v-btn>
                    </v-card-actions>

                    <v-card-text>
                      <data-table
                        :headers="headers"
                        :dataVals="dataVals"
                        :key="tableKey"
                        disable-initial-sort
                      />
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import JsonCSV from 'vue-json-csv'
import chartColumn from '@/components/Charts/ColumnBase'
import pieChart from '@/components/Charts/PieBase'
import dataTable from '@/components/Tables/TableBase'

export default {
  name: `BIDGraphics`,

  components: {
    'download-csv': JsonCSV,
    'chart-column': chartColumn,
    'pie-chart': pieChart,
    'data-table': dataTable
  },

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.operativo = this.$store.state.actualOperation.id
  },

  data: function () {
    return {
      backConf: {
        path: '/bid/preguntas/',
        page: 1
      },

      operativo: null,

      loading: false,
      progressSize: 70,
      progressWidth: 7,
      questions: [],

      req: null,
      tabs: null,

      data: null,

      pieOptions: {
        labels: [],
        legend: {
          position: 'bottom',
          horizontalAlign: 'center'
        },
        dataLabels: {
          enabled: true,
          textAnchor: 'middle',
          style: {
            fontSize: '14px'
          }
        },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0',
          '#00D9E9', '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63',
          '#FF9800', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6',
          '#18D8D8', '#A9D794', '#46AF78', '#A93F55', '#8C5E58', '#2176FF',
          '#33A1FD', '#7A918D', '#BAFF29']
      },
      pieSeries: null,

      chartOptions: {
        chart: {
          type: 'bar'
        },

        plotOptions: {
          bar: {
            distributed: true,
            dataLabels: {
              position: 'top' // top, center, bottom
            }
          }
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '14px',
            colors: ['#304758']
          }
        },

        xaxis: {
          categories: [],
          labels: {
            show: false
          },
          title: {
            text: 'Opción'
          }
        },
        yaxis: {
          title: {
            text: 'Número de Encuestas'
          }
        },
        legend: {
          position: 'bottom'
        },
        fill: {
          opacity: 1
        },
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0',
          '#00D9E9', '#FF66C3', '#546E7A', '#26a69a', '#D10CE8', '#E91E63',
          '#FF9800', '#F27036', '#663F59', '#6A6E94', '#4E88B4', '#00A7C6',
          '#18D8D8', '#A9D794', '#46AF78', '#A93F55', '#8C5E58', '#2176FF',
          '#33A1FD', '#7A918D', '#BAFF29']
      },
      chartSeries: [
        {
          name: 'Encuestas',
          data: null
        }
      ],

      headers: [
        { text: 'Opción', value: 'question' },
        { text: 'Respuestas', value: 'reply', align: 'center' },
        { text: 'Porcentaje', value: 'percentage', align: 'center' }
      ],
      labels: {
        question: 'Opción',
        reply: 'Respuestas'
      },
      dataVals: null,

      chartKey: 0,
      tableKey: 0
    }
  },

  watch: {
    req: function () {
      this.reply()
    },

    operativo: function () {
      this.changeData()
    }
  },

  computed: {
    name () {
      if (this.req) {
        let question = this.questions.filter(q => q.value === this.req)
        return question[0].text + '.csv'
      }

      return 'Respuestas.csv'
    }
  },

  methods: {
    /**
     * Obtiene las respuestas de la pregunta solicitada
     */
    reply () {
      this.loading = true

      let request = {
        method: 'get',
        params: {
          pregunta: this.req,
          operativo: this.operativo
        },
        url: this.backConf.path
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.data = resp.data
          t.processData()
          t.loading = false
        })
        .catch(function (err) {
          t.data = []
          t.loading = false
          console.error(err)
        })
    },

    /**
     * Procesa los datos de la pregunta, y los formatea
     * para ser visualizados en tabla, barras y torta
     */
    processData () {
      let lab = []
      let ser = []
      let cant = []
      let cont = 0

      this.data.forEach(function (element) {
        lab.push(element.name)
        ser.push(element.data)
        cont += element.data
      })

      this.pieOptions.labels = lab
      this.pieSeries = ser

      this.data.forEach(function (element) {
        let perc = element.data / cont * 100
        perc = Number.parseFloat(perc).toFixed(1) + ' %'
        cant.push(
          {
            question: element.name,
            reply: element.data,
            percentage: perc
          }
        )
      })

      this.chartOptions.xaxis.categories = lab
      this.chartSeries[0].data = ser

      this.dataVals = cant

      this.pieKey += 1
      this.chartKey += 1
      this.tableKey += 1
    },

    /** Cambia la lista de preguntas segun el operativo
     */
    changeData () {
      if (this.operativo === 4) { // BID Minera Piloto
        this.questions = [
          { text: 'Nivel Educativo', value: 'PxNE' },
          { text: 'Rural vs Urbano', value: 'PxRU' },
          { text: 'Reporte Aplicación por Versión', value: 'PxAV' },
          { text: 'Favorabilidad referéndum actividad minera (P55)', value: 'Px55' },
          { text: 'Favorabilidad candidato actividad minera (P56)', value: 'Px56' },
          { text: 'Encuestado necesito ayuda con la lectura', value: 'PxAL' },
          { text: 'Encuestado necesito ayuda con el manejo del DMC', value: 'PxDMC' }
        ]
      } else if (this.operativo === 9) { // BID Gobernanza Piloto
        this.questions = [
          { text: 'Nivel Educativo', value: 'PxNEG' },
          { text: 'Rural vs Urbano', value: 'PxRUG' },
          { text: 'Genero', value: 'PxGEG' },
          { text: 'Edad', value: 'PxEDG' }
        ]
      } else if (this.operativo === 23) { // BID Gobernanza Producción
        this.questions = [
          { text: 'Nivel Educativo', value: 'PxNEG' },
          { text: 'Rural vs Urbano', value: 'PxRUG' },
          { text: 'Genero', value: 'PxGEG' },
          { text: 'Edad', value: 'PxEDG' }
        ]
      }
    }
  }
}
</script>
